import React from "react";
import ModelConnectorsContainer from "../../container/modelConnector";

const ModelConnectorsScreen: React.FC<{}> = () => {
    return <ModelConnectorsContainer/>;
}

export default ModelConnectorsScreen;